// removed by extract-text-webpack-plugin
module.exports = {"root":"news-headline__root","content":"news-headline__content","headline":"news-headline__headline","posted":"news-headline__posted"};


//////////////////
// WEBPACK FOOTER
// ./src/show-page/components/news-headline/styles.less
// module id = 492
// module chunks = 1